export const handleFileChanges = (event, selectedFiles, setSelectedFiles) => {
  if (event.target.files.length === 0) return;
  const newFiles = Array.from(event.target.files).map((file) => ({
    file, // Store the file object
    name: file.name,
    isImage: /\.(jpg|jpeg|png|gif)$/i.test(file.name), // Determine if it's an image
    source: "new", // Indicate that it's a newly added file
  }));

  // Merge new files with the existing ones, ensuring no duplicates by name
  const updatedSelectedFiles = [...selectedFiles, ...newFiles].reduce(
    (unique, item) => {
      if (!unique.some((f) => f.name === item.name)) unique.push(item);
      return unique;
    },
    []
  );

  setSelectedFiles(updatedSelectedFiles);
};

export const handleRemoveFile = (setSelectedFiles, name) => {
  setSelectedFiles((prev) => prev.filter((item) => item.name !== name));
};
